import { defineMessages } from 'react-intl';

export default defineMessages({
    generalCoverages: {
        id: 'quoteandbind.RecVehProduct.views.coverages.GeneralCoverages',
        defaultMessage: 'General Coverages',
    }
    // add string ids and default values for localization here
});
